module.exports = __webpack_public_path__ + "static/sponsorship_img2M@2x-61bacce19cfb856fdfc15f960537505b.jpg";